var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVectorVertical = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: "100%",
  viewBox: "0 0 70 152",
  width: "100%",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M70 152L16 152C7.16343 152 -7.54397e-06 144.837 -7.4386e-06 136L-5.81681e-06 -8.34742e-07C-5.96059e-06 12.0569 5.61653 23.1609 14.6625 28.988L32.3374 40.3735C41.3834 46.2006 47 57.3046 47 69.3615C47 69.3615 47 110.771 47 132.131C47 152 70 152 70 152Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVectorVertical);
export default ForwardRef;